import {
  Outlet,
  createRootRoute,
  useRouterState,
} from "@tanstack/react-router";
import { AuthGate } from "@/components/AuthGate";
import { TopBar } from "@/components/TopBar";

// Root layout: persistent top bar + the active route below. Errors and
// 404s land in this component too via the router's error boundaries.
export const Route = createRootRoute({
  component: RootLayout,
  notFoundComponent: NotFoundView,
});

function RootLayout(): JSX.Element {
  const isLoading = useRouterState({ select: (s) => s.isLoading });
  return (
    <AuthGate>
      <div className="flex min-h-screen flex-col">
        <TopBar />
        <main className="mx-auto w-full max-w-screen-2xl flex-1 px-4 py-6">
          {isLoading ? (
            <div
              className="text-sm text-muted-foreground"
              data-testid="route-loading"
            >
              loading…
            </div>
          ) : null}
          <Outlet />
        </main>
      </div>
    </AuthGate>
  );
}

function NotFoundView(): JSX.Element {
  return (
    <div className="rounded-lg border border-border bg-card p-6 text-sm">
      <h1 className="text-base font-semibold text-foreground">Not found</h1>
      <p className="mt-1 text-muted-foreground">
        The URL doesn't match any helmdiver view. Head back to{" "}
        <a className="text-brand-accent hover:underline" href="/compare">
          /compare
        </a>{" "}
        to start a comparison.
      </p>
    </div>
  );
}
